import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tiktok",
  "use": "icon-tiktok-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-tiktok\"><path d=\"M15.136 1.5H2.864C2.11 1.5 1.5 2.11 1.5 2.864v12.272c0 .754.61 1.364 1.364 1.364h12.272c.754 0 1.364-.61 1.364-1.364V2.864c0-.754-.61-1.364-1.364-1.364zm-.893 6.46a2.912 2.912 0 01-2.705-1.303v4.484a3.314 3.314 0 11-3.315-3.315c.07 0 .137.006.205.01V9.47c-.068-.008-.134-.02-.205-.02a1.692 1.692 0 000 3.383c.935 0 1.76-.737 1.76-1.671L10 3.546h1.56a2.91 2.91 0 002.682 2.599V7.96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol